import { type IconButtonProps } from "@cca/components";
import { storageKeys } from "@core/constants";
import { createContext, PropsWithChildren, useContext, useEffect } from "react";
import { useLocalStorage } from "react-use";

import LightThemeLogo from "../../assets/CCAU_Logo.svg?react";
import SmallLogo from "../../assets/CCAU_Logo_Small.svg?react";
import DarkThemeLogo from "../../assets/CCAU_Logo_white.svg?react";

type SettingsContextProps = {
  theme: "light" | "dark";
  AppLogo: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  AppLogoSmall: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  ThemeSwticher: (
    props: Omit<IconButtonProps, "icon" | "onClick">,
  ) => JSX.Element;
};

function getPreferedTheme() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

const SettingsContext = createContext<SettingsContextProps>({
  theme: getPreferedTheme(),
  AppLogo: DarkThemeLogo,
  AppLogoSmall: SmallLogo,
  ThemeSwticher: () => <></>,
});

export type ThemeName = "light" | "dark";

export const SettingsProvider = ({ children }: PropsWithChildren) => {
  const preferedTheme = getPreferedTheme();
  const [] = useLocalStorage<ThemeName>(storageKeys.theme, preferedTheme, {
    raw: true,
  });

  // TODO: Remove the mock when the dark theme is ready
  const theme = "light" as ThemeName;

  useEffect(() => {
    if (theme == "dark") return document.documentElement.classList.add("dark");

    document.documentElement.classList.remove("dark");
  }, [theme]);

  const getAppLogo = () => {
    if (theme == "light") return LightThemeLogo;

    return DarkThemeLogo;
  };

  // const onThemeChange = () => {
  //   setTheme((prevTheme) => (prevTheme == "dark" ? "light" : "dark"));
  // };

  // const ThemeSwitcher =
  //   (onClickHandler: () => void) =>
  //   (props: Omit<IconButtonProps, "icon" | "onClick">) => (
  //     <IconButton
  //       icon={theme == "light" ? "moon" : "sun"}
  //       onClick={onClickHandler}
  //       {...props}
  //     />
  //   );

  return (
    <SettingsContext.Provider
      value={{
        theme: theme as ThemeName,
        AppLogo: getAppLogo(),
        AppLogoSmall: SmallLogo,
        ThemeSwticher: () => <></>,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
